module.exports = __webpack_public_path__ + "static/img/RAPD2-G_1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/produkty/RAPD2-G_1.png
// module id = tkAK
// module chunks = 0